import React from 'react';
import {useLocation} from 'react-router-dom';
import TenantDetail from './components/TenantDetail';
import {Alert, Container, Spinner} from 'react-bootstrap';
import {useTenants} from './context/TenantsContext';

const Tenants = () => {
  const {currentTenant, loading} = useTenants();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Use URL path if present (for sub-tenants/recursion), otherwise use current user's tenant
  // currentTenant.path is the full Firestore path (e.g. "tenants/A/tenants/B"), not just "tenants/{id}"
  const path = searchParams.get('path') || (currentTenant?.path ?? null);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border"/>
      </Container>
    );
  }

  if (!path) {
    return (
      <Container className="py-5">
        <Alert variant="warning">
          No tenant found for your account. Please contact an administrator.
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <TenantDetail path={path}/>
    </Container>
  );
};

export default Tenants;
